/*
 * Copyright (C) 2019 Robert Bosch GmbH Copyright (C) 2019 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
 */

import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { ConsoleLoggerService } from "./console-logger.service";
import { LogLevel } from "./loglevel";
import { LogObject } from "./logobject";

@Injectable({
  providedIn: "root",
  useExisting: ConsoleLoggerService
})
export abstract class LoggerService {
  abstract logLevel: LogLevel;

  abstract get messages$(): Observable<LogObject>;

  abstract trace(message: string, error?: Error);

  abstract debug(message: string, error?: Error);

  abstract info(message: string, error?: Error);

  abstract warn(message: string, error?: Error);

  abstract error(message: string, error?: Error);

  abstract critical(message: string, error?: Error);
}
